<script>
import Multiselect from 'vue-multiselect'


export default {
    components:{
        'vue-multiselect': Multiselect,
    },
    data: function(){
        return {
            users_tenants: [],
            users_list: []
        }
    },
    beforeMount(){
        this.getInitialData()
    },
    computed:{
        selectedUsersTenantsIds: function() {    
            var arrayPaste = []
            arrayPaste = this.users_tenants.map(a=>a.id)
            return arrayPaste
        },
        newSelectedUserstenantsIds(){
            var arrayPaste = []
            arrayPaste = this.users_tenants.filter((e)=>{return e.existent != true}).map(e=>e.id);
            return arrayPaste
        }
    },
    methods:{
        getInitialData(){
            this.users_tenants = JSON.parse(this.$attrs['data-participants-users']);
            this.users_tenants.forEach((e)=>{
                e.existent = true;
            })
            this.users_list = JSON.parse(this.$attrs["data-users"])
        },
        usersTenantsCustomLabel({email, name}){
            return `${name} - ${email}`
        },
        
    }
}
</script>